import { render } from "./techSpecDetail.vue?vue&type=template&id=09589850&scoped=true"
import script from "./techSpecDetail.vue?vue&type=script&lang=js"
export * from "./techSpecDetail.vue?vue&type=script&lang=js"

import "./techSpecDetail.vue?vue&type=style&index=0&id=09589850&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09589850"]])

export default __exports__